// ----------------------------------------------------------------------
// Vitalforce design tokens.
// One source of truth for the styled-components layer. Change a value here
// and it propagates across the hero, portfolio, team and footer bands.
// ----------------------------------------------------------------------

export const color = {
  // Warm paper ground — replaces the old cold blue/violet gradient.
  paper: '#F9F8F6',
  paperDeep: '#F1EFEA',
  white: '#FFFFFF',

  // Ink
  ink: '#3E3E3E',
  inkStrong: '#141414',
  inkMuted: '#7A756D',

  // Evergreen: the headline / link accent. "Enduring", not startup-blue.
  green: '#14513C',
  greenDeep: '#0E3B2B',
  greenTint: 'rgba(20, 81, 60, 0.06)',

  // Clay: the full-bleed footer band and hover accents.
  clay: '#D9663F',
  clayDeep: '#B84E2C',

  rule: 'rgba(20, 20, 20, 0.12)',
  ruleSoft: 'rgba(20, 20, 20, 0.07)',
};

export const font = {
  // Geometric sans for display type, set light and large.
  display: `'Jost', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  // Neutral workhorse for body copy and UI.
  body: `'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
};

// Shared page gutter, so every band lines up on the same vertical edges.
export const layout = {
  maxWidth: '1240px',
  gutter: '48px',
  gutterMobile: '24px',
};

// Small uppercase section label used above each band.
export const eyebrow = `
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${color.inkMuted};
  margin: 0;
`;
